import { Inject, Injectable } from '@angular/core';
import { PageState } from '@app-core/models/_enums';
import { AppConfiguration, AppConfigurationProvider } from '@app-core/models/config';
import { StateService } from '@app-core/services/state.service';
import { environment } from '@environments/environment';

/* eslint-disable @typescript-eslint/no-explicit-any */

@Injectable({
  providedIn: 'root'
})
export class Relay42Service {
  private _showRelayEvents: boolean;

  constructor(
    private _stateService: StateService,
    @Inject(AppConfigurationProvider) private _config: AppConfiguration
  ) {
    const { logRelay42ToConsole } = environment;
    try {
      const showRelayEvents = localStorage.getItem('showRelayEvents');
      this._showRelayEvents = showRelayEvents
        ? JSON.parse(showRelayEvents)
        : logRelay42ToConsole;
    } catch (e) {
      /* ignored */
    }
    this._stateService.getState$().subscribe(currentState => {
      switch (currentState.currentPageState) {
        case PageState.LANDINGS_PAGE:
          this.sendPageState('1-Upload je pasfoto voor een nieuwe kaart');
          break;
        case PageState.UPLOAD_PAGE:
          this.sendPageState('2-Upload je nieuwe pasfoto');
          break;
        case PageState.THANKS_PAGE:
          this.sendPageState('3-Bedankt voor je aanvraag');
          break;
      }
    });
  }

  public publishEvent($event: string, name: string, data?: any): void {
    this._relay42Fn('publishEvent', $event, name, data);
  }

  private sendPageState(pageState: string): void {
    const { _config: config } = this;
    const { nsenvironment, language, preview } = config.relay42_config;
    const { name: appName } = environment;

    this._relay42Fn('resetTags');
    this._relay42Fn('setPageStructure', 'applicatie', appName, pageState);
    this._relay42Fn('addTagProperties', {
      language,
      nsenvironment,
      preview
    });
    this._relay42Fn('loadTags');
  }

  private _relay42Fn(action: string, ...args: any[]): void {
    const { _showRelayEvents } = this;

    const relay42 = (window as any)._st;
    if (relay42) {
      relay42(action, ...args);
    }
    if (_showRelayEvents) {
      console.log(
        `[${relay42 ? 'P' : 'D'}-Relay42]: Action => `,
        action,
        ': Arguments => ',
        args
      );
    }
  }
}
